module.exports = __webpack_public_path__ + "img/wf.97574ed2.svg";